// GTM（index.html）経由で配信される第三者タグの console ログを、Sentry へ送らないために見分ける。
// これらのタグは propally_web のバンドルに存在せず、自社では直せない。ユーザー操作にも影響しないが、
// CaptureConsole（error / warn）が Sentry イベントにしてしまい、ユーザー数だけが積み上がる。
//
// 新しい第三者タグのログが Sentry に出始めたら、ここに接頭辞を足す。
type ThirdPartyTagEventLike = { message?: string; extra?: Record<string, unknown> };

export const THIRD_PARTY_TAG_LOG_PREFIXES = ["[oaiq]"];

const startsWithKnownPrefix = (value: unknown): boolean =>
  typeof value === "string" && THIRD_PARTY_TAG_LOG_PREFIXES.some((prefix) => value.startsWith(prefix));

// CaptureConsole は引数を safeJoin した文字列を event.message に、引数の配列を extra.arguments に入れるので両方を見る。
// 接頭辞は第三者 SDK 固有で自社のコードが出すことはないため、logger（console）の判定は必須にしない。
export const isThirdPartyTagConsoleNoise = (event: ThirdPartyTagEventLike): boolean => {
  const args = event.extra?.arguments;
  return startsWithKnownPrefix(event.message) || (Array.isArray(args) && startsWithKnownPrefix(args[0]));
};
